import React from 'react'
import './Locations.css'
import { Link } from 'react-router-dom'
import qatar from '../../../../assets/img/qatar.webp'
import uae from '../../../../assets/img/uae.webp'
import Bahrain from '../../../../assets/img/bahrain.webp'
import Mohali from '../../../../assets/img/mohali.webp'
import Chennai from '../../../../assets/img/chennai.webp'
import Email from '../../../../assets/img/email.webp'
import { GrLocation } from 'react-icons/gr'
import { FiPhoneCall } from 'react-icons/fi'
import { IoMdTime } from 'react-icons/io'
import { BsEnvelopePaper } from 'react-icons/bs'

function Locations() {

    const LocationData = [
        {
            img: qatar,
            Location: "Qatar",
            Address: "Al Mirqab Tower, 12th Floor WestBay, Doha, Qatar",
            Phone: "+974 4466 1996",
            Hours: "Sun to Thu - 8 AM to 5 PM"
        },
        {
            img: uae,
            Location: "UAE",
            Address: "1009, Binary Tower, marasi Drive, Business Bay, Dubai, UAE",
            Phone: "+971 52609 9677",
            Hours: "Mon to Fri - 8 AM to 5 PM"
        },
        {
            img: Bahrain,
            Location: "Bahrain",
            Address: "Avenues MAll, Manama Seafront, Bahrain",
            Phone: "+973 3353 6660",
            Hours: "Sun to Thu - 8 AM to 5 PM"
        },
        {
            img: Mohali,
            Location: "India - Mohali",
            Address: "3rd Floor, H&H Business Arcade, D-141, Phase 7, Industrial Area, Sector 73, SAS Nagar, Punjab 160055, India",
            Phone: "+91 98881 25428",
            Hours: "Mon to Fri - 10 AM to 7 PM"
        },
    ]

    return (
        <section className='cont-sec'>
            <div className='container'>
                <div className='mn-head'>
                    <h5>Contact Us</h5>
                    <h3>Catch Us For Help</h3>
                </div>
                <ul>
                    {
                        LocationData.map((Locations, index) => (
                            <li key={index}>
                                <img src={Locations.img} alt={Locations.Location} width={400} height={300} loading="lazy" />
                                <h4>{Locations.Location}</h4>
                                <p><GrLocation /> <span>Address</span><br /> {Locations.Address}</p>
                                <p><FiPhoneCall /> <span>Phone</span><br /> <a href={`tel:${Locations.Phone}`}>{Locations.Phone}</a> </p>
                                <p><IoMdTime />  <span>Working Hours</span><br /> {Locations.Hours}</p>
                            </li>
                        ))
                    }
                    <li>
                        <img src={Email} alt='Email icon' width={64} height={64} loading="lazy" />
                        <h4>Email Us</h4>
                        <p><BsEnvelopePaper /> <span>Business Enquiry</span><br /> <a href="mailto:business@360-bytes.com">business@360-bytes.com</a> </p>
                        <p><BsEnvelopePaper /> <span>Other Enquiry</span><br /> <a href="mailto:contact@360-bytes.com">contact@360-bytes.com</a> </p>
                    </li>
                </ul>
            </div>
        </section>
    )
}

export default Locations
